import React from 'react';
import { FontIcon } from 'material-ui';
import DateUtils from '../../../../../utils/date-utils';
import BookMark from 'material-ui/svg-icons/action/bookmark';
import R from 'ramda';

const SinglePickupDropOff = ({
  index,
  dateRanges,
  notes,
  timeLocArray = [],
  classes = {},
}) => {
  if (!notes && R.isEmpty(timeLocArray) && R.isEmpty(dateRanges)) return <div/>;
  return (
    <div style={{ overflow: 'auto' }} className={classes[`${index}-pickupdropoff`]}>
      <div
        style={{ fontSize: '12px',
          marginBottom: '0',
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          borderLeft: '1px solid #bababa',
          borderBottom: '1px solid #bababa',
          borderRight: '1px solid #bababa',
          borderTop: !index ? '1px solid #bababa' : '',
          color: '#262626', padding: '4px 8px',
        }}
        className={classes[`${index}-dateRanges`]}
      >
        {
          R.isEmpty(dateRanges) && (timeLocArray.length) ? (<span style={{ color: 'red' }} >Missing Dates!!!</span>)
            : (dateRanges || []).map((range, rangeIndex) => {
            return (
              <div key={rangeIndex} className={classes[`${index}-dateRanges-${rangeIndex}`]}>
                {
                  DateUtils.displayRange(range, {
                    start: classes[`${index}-dateRanges-${rangeIndex}-seasonStartDate`],
                    end: classes[`${index}-dateRanges-${rangeIndex}-seasonEndDate`],
                  })
                }
              </div>);
          })
        }
      </div>
      <div style={{ padding: '4px 8px', borderLeft: '1px solid #bababa', borderBottom: '1px solid #bababa', borderRight: '1px solid #bababa', overflow: 'auto' }}>
        {
          (timeLocArray || []).map(({ time, location }, i) => (
            <div
              key={i}
              style={{ marginBottom: i === timeLocArray.length - 1 ? 0 : '8px', display: 'flex', flexDirection: 'column' }}
              className={classes[`${index}-timeLocArray-${i}`]}
            >
              <div style={{ color: 'rgba(0,0,0,0.74)', whiteSpace: 'pre-wrap', display: location ? 'flex' : 'none', alignItems: 'center' }}>
                <FontIcon className="tc-icon-location_on" style={{ fontSize: '19px', color: 'rgba(0, 0, 0, 0.54)' }} />
                <div style={{ marginLeft: '4px' }} className={classes[`${index}-timeLocArray-${i}-location`]}>{location}</div>
              </div>
              <div style={{ color: 'rgba(0,0,0,0.74)', whiteSpace: 'pre-wrap', display: time ? 'flex' : 'none', alignItems: 'center'  }}>
                <FontIcon className="tc-icon-watch_later" style={{ fontSize: '17px', color: 'rgba(0, 0, 0, 0.54)', left: '2px' }} />
                <div style={{ marginLeft: '4px' }} className={classes[`${index}-timeLocArray-${i}-time`]}>{time}</div>
              </div>
            </div>
          ))
        }
        <div style={{ color: 'rgba(0,0,0,0.74)', whiteSpace: 'pre-wrap', marginTop: '16px', display: notes ? 'flex' : 'none', alignItems: 'flex-start' }}>
          <BookMark style={{ width: '18px', height: '18px', color: 'rgba(0, 0, 0, 0.54)' }}/>
          <span style={{ textAlign: 'left', width: '90%' }} className={classes[`${index}-notes`]}>{notes}</span>
        </div>
        <div style={{ color: 'rgba(0,0,0,0.74)', display: !notes && !(timeLocArray || []).some(obj => obj.location || obj.time) ? 'block' : 'none' }}>N/A</div>
      </div>
    </div>
  );
};

export default SinglePickupDropOff;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/right-column/single-pickupDropoff.jsx